import { Injectable } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import {
    _calcAccountsReceivableLedgerAmountWithAllowances,
    AccountsReceivableLedgerEntity, AccountsReceivableLedgerTypeEnum, financialRound,
} from '../entities/accounts-receivable-ledger.entity';
import { LedgerImportARLCalculationPreChargeByType } from '../entities/ledger-import.entity';
import {
    getARLCostAmountWithAllowance,
    getParentsBaseCostAllowanceCharges,
} from '../../dave-reports/components/arl-calculation/arl-calculation.helper';
import Big from 'big.js';

@Injectable({
  providedIn: 'root'
})
export class ArlInputBuilderService {
    //Berechnung dieselbe wie für Preise übernehmen im Arl-Dialog
    buildArlInputs(
        selectedArlIds: number[],
        arlDictionary: Dictionary<AccountsReceivableLedgerEntity>,
        preChargeByTypes: LedgerImportARLCalculationPreChargeByType[],
        currencyCalcFactor = 100 ): { id: number; baseCost: number; lohnBaseCostPart: number; costAmount: number; baseCostGross: number }[] {
        const toCents = (value: number) => financialRound(value * currencyCalcFactor, 0);
        const withParentAllowances = (arl: AccountsReceivableLedgerEntity, basePrice: number): number =>

                _calcAccountsReceivableLedgerAmountWithAllowances(
                    { Type: arl.Type, SurchargeOverride: arl.SurchargeOverride, FixedPrices: arl.FixedPrices, BaseCostAllowances: arl.BaseCostAllowances || [] },
                    getParentsBaseCostAllowanceCharges(arl.Id, arlDictionary).map((a) => a || []),
                    basePrice || 0,
                    false,
                    true,
                );
        const getPreCharge = (type: AccountsReceivableLedgerTypeEnum) => preChargeByTypes.find((c) => c.arlType === type)?.percentage || 0;
        const getEkWithPreCharge = (arl: AccountsReceivableLedgerEntity) => {
            const cost = getARLCostAmountWithAllowance(arl);
            return cost+(cost*(getPreCharge(arl.Type)));
        };
        const getCostAmount = (arl: AccountsReceivableLedgerEntity): number => {
            if (arl.isBookingPosition && !arl.FixedPrices) {
                const parent = arl.ParentId ? arlDictionary[arl.ParentId] : null;
                if (parent && parent.Type !== AccountsReceivableLedgerTypeEnum.Group && selectedArlIds.includes(parent.Id)) {
                    return getEkWithPreCharge(arl);
                } else if (arl.InheritFromChildren && arl.Type !== AccountsReceivableLedgerTypeEnum.Group) {
                    return (arl.ArlIds || [])
                        .map((cId) => arlDictionary[cId])
                        .filter(Boolean)
                        .reduce((sum, child) => sum+(getEkWithPreCharge(child)*(child.Quantity)), 0);
                }
            }
            return arl.CostAmount;
        };

        return selectedArlIds
            .map((id) => arlDictionary[id])
            .filter(Boolean)
            .map((arl) => ({
                id: arl.Id,
                baseCost: toCents(withParentAllowances(arl, arl.BaseCost)),
                baseCostGross: toCents(withParentAllowances(arl, arl.BaseCostGross)),
                lohnBaseCostPart: toCents(withParentAllowances(arl, arl.SalaryBaseCost)),
                costAmount: toCents(getCostAmount(arl)),
            }));
    }
  constructor() { }
}
